<template>
  <div class="container">
    <a-popover v-model="visible" placement="bottomLeft" trigger="click">
      <template slot="content">
        <div class="ope-div">
          <div>
            <a-button v-if="llmInfo.type === -1" type="primary" @click="getLlmSuggestion">获取建议</a-button>
            <div v-if="llmInfo.type === 0 || llmInfo.type === 1" class="ai-loading-container">
              <div class="ai-loading">
                <div class="ai-circle" />
                <div class="ai-circle" />
                <div class="ai-circle" />
                <div class="ai-pulse" />
              </div>
              <span class="ai-text">AI评分中...</span>
            </div>
            <a-button v-if="llmInfo.type === 2" type="primary" @click="getLlmSuggestion">重新获取</a-button>
          </div>
          <a-button v-if="llmInfo.type === 2" type="primary" @click="llmEdit">去编辑</a-button>
        </div>
        <div v-if="llmInfo.suggestion_detail" class="suggestion-group">
          <div v-if="totalSuggestion" class="suggestion-card total-card">
            <div class="suggestion-title">
              <span class="suggestion-icon">💡</span>
              <span>综合建议</span>
            </div>
            <div class="suggestion-content">{{ totalSuggestion }}</div>
          </div>
          <div v-for="item in restSuggestions" :key="item.key" class="suggestion-card">
            <div class="suggestion-title">
              <span class="suggestion-icon">{{ item.icon }}</span>
              <span>{{ item.label }}</span>
            </div>
            <div class="suggestion-content">{{ item.content }}</div>
          </div>
        </div>
      </template>
      <div @click="openLLmSuggestion"><svg-icon type="ai" style="font-size: 40px; vertical-align: middle" /></div>
      <!-- <a-button type="primary" shape="circle" icon="robot" @click="openLLmSuggestion" /> -->
    </a-popover>
  </div>
</template>

<script>
import { issueLlmSuggestion } from '@/api/project/issue';

const SUGGESTION_MAP = [
  { key: 'title_accuracy', label: '标题规范性', icon: '🏷️' },
  { key: 'colloquial', label: '表述规范', icon: '📝' },
  { key: 'information_integrity', label: '信息完整性', icon: '📄' },
  { key: 'operating_step', label: '操作步骤', icon: '🧭' },
  { key: 'problem_location', label: '根因分析', icon: '🔍' }
];

export default {
  props: {
    llmInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      visible: false,
      projectId: parseInt(this.$route.params.project_id) || null,
      issueId: parseInt(this.$route.query.issueId) || null
    };
  },
  computed: {
    totalSuggestion() {
      return this.llmInfo && this.llmInfo.suggestion_detail && this.llmInfo.suggestion_detail.total;
    },
    restSuggestions() {
      if (!this.llmInfo || !this.llmInfo.suggestion_detail) return [];
      const detail = this.llmInfo.suggestion_detail;
      return SUGGESTION_MAP.map(item => ({
        ...item,
        content: detail[item.key]
      })).filter(item => item.content);
    }
  },
  methods: {
    llmEdit() {
      this.visible = false;
      this.$emit('llm-edit');
    },
    getLlmSuggestion() {
      // eslint-disable-next-line vue/no-mutating-props
      this.llmInfo.type = 0;
      issueLlmSuggestion({
        project_id: this.projectId,
        issue_id: this.issueId
      }).finally(() => {
        // eslint-disable-next-line vue/no-mutating-props
        this.llmInfo.type = -1;
      });
    },
    openLLmSuggestion() {
      this.utils.trackClick({ name: '查看llm缺陷改进建议' });
    }
  }
};
</script>

<style scoped lang="less">
.container {
  display: inline-flex;
  align-items: center;
}

.ope-div {
  width: 600px;
  display: flex;
  justify-content: space-between;
}

.suggestion-group {
  width: 600px;
  margin-top: 18px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.suggestion-card {
  background: #f6faff;
  border-radius: 10px;
  box-shadow: 0 2px 8px 0 rgba(24, 144, 255, 0.06);
  padding: 14px 18px 12px 18px;
  border: 1px solid #e6f7ff;
  transition: box-shadow 0.2s;
  &:hover {
    box-shadow: 0 4px 16px 0 rgba(24, 144, 255, 0.13);
    border-color: #91d5ff;
  }
}
.total-card {
  background: linear-gradient(90deg, #e0f7fa 60%, #fffbe6 100%);
  border: 1.5px solid #ffe58f;
  box-shadow: 0 4px 18px 0 rgba(255, 215, 0, 0.1);
}
.suggestion-title {
  font-size: 15px;
  font-weight: 600;
  color: #1890ff;
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  gap: 6px;
}
.total-card .suggestion-title {
  color: #faad14;
}
.suggestion-icon {
  font-size: 18px;
  margin-right: 2px;
}
.suggestion-content {
  font-size: 14px;
  color: #333;
  line-height: 1.7;
  word-break: break-all;
}

.ai-text {
  color: #1890ff;
  font-size: 14px;
  font-weight: 500;
  background: linear-gradient(90deg, #1890ff, #52c41a);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: ai-text-shine 2s linear infinite;
}

.ai-loading-container {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  margin-right: 8px;
}

.ai-loading {
  position: relative;
  width: 20px;
  height: 20px;
  margin-right: 6px;
}

.ai-circle {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 1.5px solid transparent;
  border-top-color: #1890ff;
  border-radius: 50%;
  animation: ai-spin 1.5s linear infinite;

  &:nth-child(2) {
    border-top-color: #52c41a;
    animation-delay: 0.5s;
  }

  &:nth-child(3) {
    border-top-color: #722ed1;
    animation-delay: 1s;
  }
}

@keyframes ai-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes ai-text-shine {
  0% {
    background-position: -100% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>
